// lib

import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

import { default as ControlsContainer } from '@aytm/app/stats/page/question-views/components/questions-custom/Controls'

// styles

const Controls = ({ model, data, collapsed, disabled, onToggle, onChange }) => {
  const itemTemplate = option => <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
  const valueTemplate = (option, _props) => (
    <span
      dangerouslySetInnerHTML={{ __html: option ? option.label || option.text : _props.placeholder || 'Select...' }}
    ></span>
  )

  return (
    <ControlsContainer model={model} data={data} collapsed={collapsed} onToggle={onToggle}>
      <div className="p-fluid p-col-5">
        <Dropdown
          data-testid="stat-dl-cq-mode"
          className="p-dropdown-rounded"
          aria-label="Analysis mode"
          ariaLabel="Analysis mode"
          value={model.mode}
          options={data.controls.mode.options}
          optionValue="key"
          optionLabel="text"
          fixedDropdownDir="bottom"
          disabled={disabled || data.controls.mode.disabled}
          itemTemplate={itemTemplate}
          valueTemplate={valueTemplate}
          onChange={disabled || data.controls.mode.disabled ? null : event => onChange('mode', event.value)}
        />
      </div>
    </ControlsContainer>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
  onChange: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
